export default () => {
  const domain = window.location.hostname.split('.').shift()
  return domain
}
